import React, {useEffect, useState} from "react";
import PanelForm from "../panel/Form";
import {useNavigate} from "react-router-dom";
import {createSearchParams} from "react-router";
import ListItem from "./ListItem"

export default function List(props) {

    const navigate = useNavigate();

    return (
        <div>

            <div className="wrapper">
                {props.trips != null && props.trips.length === 0 && (
                    <center>
                        <PanelForm style={{maxWidth: '640px', background: '#FFFFFF', margin: 25, padding: 25, marginTop: 'calc(50vh - 400px)'}}>
                            <div style={{fontSize: 18}}>
                                Für diese Auswahl wurden keine passenden Kurse gefunden.
                            </div>
                        </PanelForm>
                    </center>
                )}


                {props.trips != null && props.trips.length >= 1 && (
                    <div className="flex flex-wrap" style={{justifyContent: 'center', padding: '30px'}}>

                        {props.trips?.map( (trip => (
                            <ListItem
                                trip={trip}
                                onClick={(trip) => {
                                    navigate({
                                        pathname: '/trip',
                                        search: `?${createSearchParams({id: trip.id, appointment: props.selectedAppointment})}`,
                                    })
                                    window.scrollTo(0, 0);
                                }}
                            />
                        )))}
                    </div>
                )}
            </div>
        </div>
    )


}